import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, injectIntl } from 'react-intl'
import { ScoringChart } from 'gnos-charts'

import ToggleButton from '../../../../../../../../../../components/ToggleButton'
import { LOCALE_PREFIX } from '../../../Blocks/PaymentComparison/constants'

import DataTable from './components/DataTable'

import hocConnect from './hocConnect'
import './style.scss'

@injectIntl
@hocConnect
export default class Chart extends Component {
    static propTypes = {
        data: PropTypes.array,
        originalData: PropTypes.array,
        block: PropTypes.string.isRequired,
        module: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired,
        intl: PropTypes.object,
        paymentComparisonToggleChartDataTable: PropTypes.func.isRequired,
        showChartDataTable: PropTypes.bool,
    }

    onToggleDataTable = () => {
        const { paymentComparisonToggleChartDataTable, module, block, id, showChartDataTable } = this.props

        paymentComparisonToggleChartDataTable(module, block, id, showChartDataTable)
    }

    render() {
        const { data, originalData, id, intl, showChartDataTable } = this.props

        return (
            <div className={'payment-comparison-graph-wrapper'}>
                <div className={'chart-header'}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.dataTable`} />
                    <div className={'toggle-btn-container'}>
                        <ToggleButton
                            active={!!showChartDataTable}
                            inactiveGreyBackground
                            onClickHandler={this.onToggleDataTable}
                            textOff={intl.formatMessage({ id: `${LOCALE_PREFIX}.no` })}
                            textOn={intl.formatMessage({ id: `${LOCALE_PREFIX}.yes` })}
                        />
                    </div>
                </div>
                <div className={'chart-container'}>
                    <ScoringChart
                        key={`payment-comparison-scoring-chart-${id}`}
                        dataProvider={data}
                        dateFormat={'DD-MM-YYYY'}
                        categoryField={'date'}
                        showLegend
                        showValueAxisBaloon
                        automaticScale
                        reversedScale
                        graphs={[
                            {
                                id: `payment-comparison-scoring-payment-index-${id}`,
                                title: intl.formatMessage({ id: `${LOCALE_PREFIX}.paymentIndex` }),
                                dataSelector: 'paymentIndex',
                                type: 'line',
                                lineColor: '#27358b',
                                lineThickness: 1,
                                fillAlphas: 0,
                                negativeLineColor: '#27358b',
                                negativeFillAlphas: 0,
                                balloonColor: '#27358b',
                                balloonTextColor: '#FFFFFF',
                                fillColors: '#27358b',
                                negativeFillColors: '#27358b',
                                balloonBorderColor: '#27358b',
                                balloonBorderThickness: 0,
                                balloonTexts: [
                                    {
                                        label: intl.formatMessage({ id: `${LOCALE_PREFIX}.daysAfterDueBalloon` }),
                                        dataSelector: 'paymentIndex',
                                    },
                                ],
                            },
                            {
                                id: `payment-comparison-scoring-sector-payment-index-${id}`,
                                title: intl.formatMessage({ id: `${LOCALE_PREFIX}.sectorPaymentIndex` }),
                                dataSelector: 'sectorPaymentIndex',
                                type: 'line',
                                lineColor: '#662D91',
                                lineThickness: 1,
                                fillAlphas: 0,
                                negativeLineColor: '#662D91',
                                negativeFillAlphas: 0,
                                balloonColor: '#662D91',
                                fillColors: '#662D91',
                                negativeFillColors: '#662D91',
                                balloonBorderColor: '#662D91',
                                balloonTextColor: '#FFFFFF',
                                balloonBorderThickness: 0,
                                balloonTexts: [
                                    {
                                        label: intl.formatMessage({ id: `${LOCALE_PREFIX}.daysAfterDueBalloon` }),
                                        dataSelector: 'sectorPaymentIndex',
                                    },
                                ],
                            },
                            {
                                id: `payment-comparison-scoring-supplier-payment-index-${id}`,
                                title: intl.formatMessage({ id: `${LOCALE_PREFIX}.supplierPaymentIndex` }),
                                dataSelector: 'supplierPaymentIndex',
                                type: 'line',
                                lineColor: '#29ABE2',
                                lineThickness: 1,
                                fillAlphas: 0,
                                negativeLineColor: '#29ABE2',
                                negativeFillAlphas: 0,
                                balloonColor: '#29ABE2',
                                fillColors: '#29ABE2',
                                negativeFillColors: '#29ABE2',
                                balloonBorderColor: '#29ABE2',
                                balloonTextColor: '#FFFFFF',
                                balloonBorderThickness: 0,
                                balloonTexts: [
                                    {
                                        label: intl.formatMessage({ id: `${LOCALE_PREFIX}.daysAfterDueBalloon` }),
                                        dataSelector: 'supplierPaymentIndex',
                                    },
                                ],
                            },
                            {
                                id: `payment-comparison-scoring-club-payment-index-${id}`,
                                title: intl.formatMessage({ id: `${LOCALE_PREFIX}.clubPaymentIndex` }),
                                dataSelector: 'clubPaymentIndex',
                                type: 'line',
                                lineColor: '#d53868',
                                lineThickness: 1,
                                fillAlphas: 0,
                                negativeLineColor: '#d53868',
                                negativeFillAlphas: 0,
                                balloonColor: '#d53868',
                                fillColors: '#d53868',
                                negativeFillColors: '#d53868',
                                balloonBorderColor: '#d53868',
                                balloonTextColor: '#FFFFFF',
                                balloonBorderThickness: 0,
                                balloonTexts: [
                                    {
                                        label: intl.formatMessage({ id: `${LOCALE_PREFIX}.daysAfterDueBalloon` }),
                                        dataSelector: 'clubPaymentIndex',
                                    },
                                ],
                            },
                        ]}
                        style={{ height: '500px', width: '100%', marginBottom: '-21px' }}
                        monthNames={[
                            intl.formatMessage({ id: 'global.january' }),
                            intl.formatMessage({ id: 'global.february' }),
                            intl.formatMessage({ id: 'global.march' }),
                            intl.formatMessage({ id: 'global.april' }),
                            intl.formatMessage({ id: 'global.may' }),
                            intl.formatMessage({ id: 'global.june' }),
                            intl.formatMessage({ id: 'global.july' }),
                            intl.formatMessage({ id: 'global.august' }),
                            intl.formatMessage({ id: 'global.september' }),
                            intl.formatMessage({ id: 'global.october' }),
                            intl.formatMessage({ id: 'global.november' }),
                            intl.formatMessage({ id: 'global.december' }),
                        ]}
                    />
                </div>
                {showChartDataTable && (
                    <div className={'data-table-container'}>
                        <DataTable id={id} data={originalData?.[1]?.table} />
                    </div>
                )}
            </div>
        )
    }
}
